import React from "react";
import PropTypes from "prop-types";
import { ResponsiveHeroImage, ReviewRating } from "@quintype/components";
import { CustomLink } from "../custom-link";
import { ImageFallback } from "./image-fallback.js";
import get from "lodash/get";
import { breakpoint } from "../../../utils/breakpoint";
import { altTagOfHeroImages, isExternalStory } from "../../utils";
import { GlideCarousel } from "../../components/atoms/glide";
import { truncate } from "../../../utils/truncate-string";

function SimpleSlider(props) {
  const eager = get(props, ["eager"], false);
  let resizeDone = false;

  const resize = () => {
    if (resizeDone === false) {
      global.dispatchEvent(new global.Event("resize"));
      resizeDone = true;
    }
  };

  const options = {
    afterSlide: resize,
    perView: 1,
    arrow: true,
    dot: "",
    autoplay: 5000,
    rtl: get(props.config, ["theme-attributes", "language_direction"]) === "right"
  };

  const SliderWrapper = (
    <GlideCarousel {...options}>
      {props.stories.map((item, index) => {
        const initialVisibleSlidesEager = index === 0 ? eager : false;
        return (
          <div key={item.id}>
            <SliderItem
              eager={initialVisibleSlidesEager}
              item={item}
              heading={props.heading}
              associatedMetadata={props.associatedMetadata}
            />
          </div>
        );
      })}
    </GlideCarousel>
  );

  if (!props.stories.length) return null;

  return <div className="simple-slider">{SliderWrapper}</div>;
}

SimpleSlider.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.array,
  heading: PropTypes.string,
  eager: PropTypes.bool,
  associatedMetadata: PropTypes.object
};

function SliderItem(props) {
  /* The `story` can be an item from items of a collection or a story itself.
    assigning it accordinlgy. */
  const story = props.item && props.item.type === "story" && props.item.story ? props.item.story : props.item;
  const isReviewStory = story["story-template"] === "review";
  const aspectRatio = breakpoint("tablet") ? [4, 3] : [9, 3];
  const eager = get(props, ["eager"], false);
  const {
    associatedMetadata: { button_text: buttonText = "Read Story", show_collection_title: showTitle = true }
  } = props;

  return (
    <div className="simple-slider__item">
      {story["hero-image-s3-key"] ? (
        <figure className={`${story["story-template"] === "video" ? "simple-slider__image__video" : ""}`}>
          <ResponsiveHeroImage
            story={story}
            aspectRatio={aspectRatio}
            alt={altTagOfHeroImages(story)}
            defaultWidth={480}
            widths={[480, 640, 1150]}
            sizes="(max-width: 500px) 23vw, (max-width: 768px) 48vw, 98vw"
            imgParams={{ auto: ["format", "compress"], fit: "max" }}
            eager={eager}
          />
        </figure>
      ) : (
        <ImageFallback bgColor="#adc1d6" story={story} />
      )}
      <div className="simple-slider__content">
        {showTitle && (
          <p className="simple-slider__section-name" data-test-id="simple-slider-section-name">
            {props.heading}
          </p>
        )}

        <h2 className="simple-slider__story-heading" data-test-id="simple-slider-headling">
          <bdi dangerouslySetInnerHTML={{ __html: story.headline }} />
        </h2>
        {isReviewStory && <ReviewRating value={get(story, ["metadata", "review-rating", "value"], "0")} />}
        <CustomLink
          href={"" + story.url}
          externalLink={isExternalStory(story)}
          className="simple-slider__link"
          data-test-id="simple-slider-readmore-link"
        >
          {buttonText ? truncate(buttonText, 50, false) : "Read Story"}
        </CustomLink>
      </div>
    </div>
  );
}
SliderItem.propTypes = {
  item: PropTypes.object,
  heading: PropTypes.string,
  eager: PropTypes.bool,
  associatedMetadata: PropTypes.object
};

export { SimpleSlider };
